export default __webpack_public_path__ + "static/O0180-452370f9233ae1e05ec702a48530432e.png";